import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-cy"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    return (_openBlock(), _createElementBlock("div", {
        "data-cy": _ctx.testId,
        class: _normalizeClass(_ctx.rootDrawerToggleButtonClass),
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.handleClickBtn && _ctx.handleClickBtn(...args)))
    }, [
        _createCommentVNode(" default arrow direction = left, 주문쪽 버튼 dialog 열려있을 때 "),
        _createElementVNode("div", {
            class: _normalizeClass(_ctx.btnClass)
        }, [
            _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" mdi-chevron-left ")
                ])),
                _: 1 /* STABLE */,
                __: [1]
            }),
            _createCommentVNode(" <img\n        width=\"7px\"\n        src=\"/svg/arr-left.svg\"\n      /> ")
        ], 2 /* CLASS */)
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
